/**
 * This is a list of constants for global events, right now it's only used by global event bus,
 * but it's not limit to it.
 */
export class GlobalEvents {
  // be careful not to change the strings of the following, "restored" and "minimized" is key in ticket controller
  // start
  public static readonly rcBarRestored: string = 'rcBarRestored';
  public static readonly rcBarMinimized: string = 'rcBarMinimized';
  public static readonly associationBarRestored: string = 'associationBarRestored';
  public static readonly associationBarMinimized: string = 'associationBarMinimized';
  // end

  public static readonly previewSnapshot: string = 'previewSnapshot';
  public static readonly previewAttachment: string = 'previewAttachment';
  public static readonly remoteControlTabSelected: string = 'remoteControlTabSelected';
  public static readonly viewTicketActivePanels: string = 'viewTicketActivePanels';
  public static readonly activityDeleted: string = 'activityDeleted';
  public static readonly openLiveSnapshot: string = 'openLiveSnapshot';
  public static readonly openRcWorkPanel: string = 'openRcWorkPanel'; // simply show RC in workpanel, rc may or may not be connected already.
  public static readonly closeRcWorkPanel: string = 'closeRcWorkPanel'; // simply close RC in workpanel, rc may or may not be connected already.
  public static readonly leftWorkPanelOpen: string = 'leftWorkPanelOpen'; // published by ticket controller when left panel open
  public static readonly leftWorkPanelClose: string = 'leftWorkPanelClose'; // published by ticket controller when left panel closed
  public static readonly startRemoteControl: string = 'startRemoteControl'; // when user request to start rc, listener should in ticket controller, entry point of starting rc
  public static readonly startRemoteControlFromPopOut: string = 'startRemoteControlFromPopOut'; // when user request to start rc, from an already popped out window
  public static readonly startRemoteControlFromStandaloneRC: string = 'startRemoteControlFromStandaloneRC'; // when user request to re-start rc from standalone rc window
  public static readonly remoteControlCloseInitiated: string = 'remoteControlCloseInitiated'; // when user clicks close button on the rc panel or rc activity
  public static readonly remoteControlCompleteTransfer: string = 'remoteControlCompleteTransfer'; // when user clicks close button on the rc panel or rc activity

  public static readonly remoteControlOpenPopoutWindow: string = 'remoteControlOpenPopoutWindow';
  public static readonly remoteControlCanvasReady: string = 'remoteControlCanvasReady';
  public static readonly remoteControlSafeToStart: string = 'remoteControlSafeToStart';
  public static readonly remoteControlMinimized: string = 'remoteControlMinimized'; // when rc or live snapshot minimized, but work panel could still be open
  public static readonly remoteControlMaximized: string = 'remoteControlMaximized';
  public static readonly remoteControlError: string = 'remoteControlError'; // when any rc error is raised
  public static readonly remoteControlStarted: string = 'remoteControlStarted';
  public static readonly remoteControlEnded: string = 'remoteControlEnded';
  public static readonly remoteControlMultiScreenVisualSelection: string = 'remoteControlMultiScreenVisualSelection';

  // Occurs when user clicked popOut button.
  public static readonly popOutStarted: string = 'popOutStarted';
  // Occurs when user clicked popIn button.
  public static readonly popInStarted: string = 'popInStarted';

  public static readonly attachScreenshot: string = 'attachScreenshot';
  public static readonly resolutionNoteRequired: string = 'resolutionNoteRequired';

  /** Fired when the ticket page finished loading (used to check if snapshot panel should finish transfering from standalone)*/
  public static readonly ticketLoaded: string = 'ticketLoaded';

  /** Fired from the signOut page */
  public static readonly signedOut: string = 'signedOut';

  /** SignalR init completed event */
  public static readonly signalrInitialized: string = 'signalrInitialized';
  /** SignalR Topic subscription event */
  public static readonly subscribeTopic: string = 'subscribeTopic';
  /** SignalR Topic unsubscription event */
  public static readonly unsubscribeTopic: string = 'unsubscribeTopic';
  /** SignalR Topic for the Ticket Updated message */
  public static readonly topicTicketUpdated: string = 'topicTicketUpdated';
  /** SignalR Topic for the Support Request Created message */
  public static readonly topicSupportRequestCreated: string = 'topicSupportRequestCreated';
  /** SignalR Topic for the Support Request Status Changed message */
  public static readonly topicSupportRequestUpdated: string = 'topicSupportRequestUpdated';
  /** SignalR Topic for the Support Request Assign message */
  public static readonly topicSupportRequestAssign: string = 'topicSupportRequestAssign';

  /** RC - FileManager Upload file statuscenter update event */
  public static readonly fileUploadUpdated: string = 'fileUploadUpdated';
  /** RC - FileManager Download file statuscenter update event */
  public static readonly fileDownloadUpdated: string = 'fileDownloadUpdated';
  /** RC - FileManager Download file event */
  public static readonly fileDownloadTriggered: string = 'fileDownloadTriggered';
  /** RC - FileManager Compress Folder event */
  public static readonly ItemCompressTriggered: string = 'ItemCompressTriggered';
  /** RC - FileManager Compress and Download Folder event */
  public static readonly ItemCompressAndDownloadTriggered: string = 'ItemCompressAndDownloadTriggered';

  /** Toast - Show toast message event */
  public static readonly showToastMessage: string = 'showToastMessage';

  /** Shows a message on the snack bar */
  public static readonly showSnackbarMessage: string = 'showSnackbarMessage';

  /** Shows an error message for three dots device menus */
  public static readonly deviceMenuErrorMessage: string = 'deviceMenuErrorMessage';
}
